import { Switch, type SwitchProps } from '@chakra-ui/react';

export type UiSwitchProps = SwitchProps;

export const UiSwitch = Switch;
